// import { getRequest } from './getRequest';
// import axios from 'axios';
// import CryptoJS from "crypto-js";

// const SECRET_KEY = "1234567890abcdef1234567890abcdef";

// function decryptFunction(ciphertext, key) {
//   // Decrypt
//   let bytes = CryptoJS.AES.decrypt(ciphertext, key);
//   let decryptedData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
//   console.log("hello data ", decryptedData);
//   return decryptedData;
// }

// // Function to handle GET request
// export async function getProcessOppurtunitiesAPI() {
//   const baseUrl = process.env.REACT_APP_GET_PROCESS_OPPORTUNITY_API;
// //   const url = `${baseUrl}`;
// //   return getRequest(baseUrl);  // Perform GET request
// const config = {
//     headers: { "Access-Control-Allow-Origin": true },
//   };
// //   if (flag) {
// //     url += `&email=${encodeURIComponent(email.data)}`;
// //   }
//   console.log("i m here");
//   const data = await axios.get(baseUrl);
//   // console.log("data", data.data);
//   const decrypteddata = decryptFunction(data.data, SECRET_KEY);
//   console.log("scarlet", decrypteddata);
//   return decrypteddata;
// }
import { getRequest, handleLogout } from "./getRequest";
import axios from "axios";
import CryptoJS from "crypto-js";

const SECRET_KEY = "1234567890abcdef1234567890abcdef";

function decryptFunction(ciphertext, key) {
  // Decrypt
  let bytes = CryptoJS.AES.decrypt(ciphertext, key);
  let decryptedData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
  console.log("hello data ", decryptedData);
  return decryptedData;
}

// Function to handle GET request
export async function getProcessOppurtunitiesAPI() {
  const baseUrl = `${process.env.REACT_APP_GET_PROCESS_OPPORTUNITY_API}&type=process`;
  const authToken = localStorage.getItem("authToken");

  console.log("i m here");

  let data;
  try {
    data = await axios.get(baseUrl, {
      headers: {
        Authorization: `Bearer ${authToken}`,
      },
    });
  } catch (error) {
    if (error.status === 401) {
      console.log("Token expired");
      handleLogout();
      return;
    }
    throw error;
  }

  const decrypteddata = decryptFunction(data.data, SECRET_KEY);
  console.log("scarlet", decrypteddata);

  return decrypteddata;
}
